export default {
	state: {
		deliveryAreas: [],
		selectedDeliveryArea: null
	},

	mutations: {
		setDeliveryAreas(store, payload) {
			store.deliveryAreas = payload
		},
		setSelectedDeliveryArea(store, payload) {
			store.selectedDeliveryArea = payload
		}
	},

	actions: {
    async getEnableDeliveryAreas({ dispatch }) {
      return (await dispatch('apiGuestRequest', {method: 'GET', endpoint: '/delivery-area/enable'})).enable
    },
		async loadDeliveryAreas({ commit, dispatch }) {
			await commit('setDeliveryAreas', await dispatch('apiGuestRequest', {method: 'GET', endpoint: '/delivery-area/'}))
		},
	},

	getters: {
		deliveryAreas(store) {
			return store.deliveryAreas
		},
		selectedDeliveryArea(store) {
			return store.selectedDeliveryArea
		}
	}
}